<template>
  <!-- start navigator -->
  <div class="container ps-lg-5 pe-lg-5 mt-1">
    <div class="row">
      <div
        class="
          col-12
          d-none d-lg-flex
          justify-content-between
          align-items-center
        "
      >
        <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link
                class="text-decoration-none router-link"
                to="/AgenteService"
                >หน้าแรก</router-link
              >
            </li>
            <li class="breadcrumb-item router-link active">ขอโอนผลงาน</li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <!-- end navigator -->
  <div class="container-lg">
    <div class="row">
      <!-- Left Menu -->
      <div class="col-left-menu">
        <div class="left-menu">
          <ul class="d-none d-lg-block">
            <Menu />
          </ul>
        </div>
      </div>
      <!-- Left Menu -->
      <!-- Mobile -->
      <div
        class="
          col-left-menu
          d-flex d-lg-none
          border-bottom
          align-items-center
          border-bottom
          w-100
          pl-3
          pr-3
        "
        style="background-color: #f2f2f2"
      >
        <div class="icon-back">
          <router-link to="/AgenteService">
            <img src="@/assets/images/arrow-blue.svg" class="w-100" />
          </router-link>
        </div>
        <div
          class="title ps-md-3 ps-lg-3 d-block d-lg-none text-center w-100"
          style="font-family: DB Heavent; color: #0057a8"
        >
          ขอโอนผลงาน
        </div>
      </div>
      <!-- Mobile -->
      <div class="col mb-2">
        <div class="d-none d-lg-flex align-items-center border-bottom">
          <div class="icon-back">
            <router-link to="/AgenteService">
              <img src="@/assets/images/arrow-blue.svg" class="w-100" />
            </router-link>
          </div>
          <div
            class="
              title
              blue-1
              fw-normal
              ps-md-3
              pe-lg-3
              font-family
              d-none d-md-block d-lg-block
            "
          >
            ขอโอนผลงาน
          </div>
        </div>
        <div class="pb-3 pb-lg-3 mt-2 mt-lg-1">
          <div class="gray-3 fs-5 font-family">
            ระบุตัวแทนที่ต้องการโอนผลงานให้<span class="required">*</span>
          </div>
          <div class="ps-2 row font-family">
            <div class="col-11" style="padding-right: initial">
              <input
                v-model="this.AgentCode"
                type="text"
                class="field field__input a-field__input fs-6 bla-placeholder"
                style="border-bottom: 1px solid #d0d0d0; font-family: monospace;"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                placeholder="รหัสตัวแทน"
                maxlength="8"
                @change="format(this.AgentCode)"
              />
            </div>
            <div class="col-1" style="padding-left: inherit">
              <font-awesome-icon
                class="Icon-Search"
                :icon="IconSearch"
                @click="Search(this.AgentCode)"
              />
            </div>
            <div v-if="this.POL_CODE !== '' || this.POL_CODE != null" >
              <label class="font-family fs-5 fw-normal blue-1">{{ this.POL_PRENAME }} {{ this.POL_NAME }} {{ this.POL_SURNAME }}</label>
            </div>
          </div>
        </div>
        <div class="col mt-2 mb-2 mb-lg-2">
          <button class="btn-CB border border-0 rounded w-100 font-family" @click="EnterNext()" :disabled="disabled">
            <label class="btn-next">ดำเนินการต่อ</label>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div v-if="this.Loading">
    <LoadingBs5></LoadingBs5>
  </div>
</template>

<script>
import Menu from "@/components/agenteservice/Menu.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";

import LoadingBs5 from "@/components/frontend/LoadingBs5";
import http from "@/services/AuthService";
import Swal from 'sweetalert2/src/sweetalert2.js'

export default {
  name: "TranferWorkView",
  components: {
    Menu,
    FontAwesomeIcon,
    LoadingBs5
  },
  data() {
    return {
      IconSearch: faMagnifyingGlass,
      AgentCode: '',
      Loading: true,
      CheckSearch: false,
      POL_CODE: '',
      POL_PRENAME: '',
      POL_NAME: '',
      POL_SURNAME: '',
      disabled: false
    };
  },
  mounted() {
    if(this.$store.state.AgentCode == '') {
      this.$router.push('/');
    }

    // let AuthorizeToken = this.$cookies.get("AuthorizeToken");
    let AuthorizeToken = localStorage.getItem("AuthorizeToken");
    http.get("AgencyERequest/GetName?",{ headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((res) => { 
      if(res.status == 200) {
        this.$store.state.UserName = res.data.NAME + " " + res.data.SURNAME;
        this.Loading = false;
      }
    }).catch((error) => { 
      Swal.fire({
        icon: 'error',
        html: '<label class="fs-4 fw-normal font-family">'+ error.response.data.ErrorMessage +'</label>',
      }).then(() => { 
        localStorage.removeItem("Token");
        localStorage.removeItem("AuthorizeToken");
        window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor/Logout", '_self');
      });
    });
  },
  watch: {
    AgentCode() {
      this.POL_CODE = '';
      this.POL_PRENAME = '';
      this.POL_NAME = '';
      this.POL_SURNAME = '';

      this.CheckSearch = false;
    },
  },
  methods: {    
    Search(val) { 
      if(val === '') {
        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">กรุณาระบุตัวแทนที่ต้องการโอนผลงานให้</label>',
        });
      }
      else {
        this.Loading = true;
        // let AuthorizeToken = this.$cookies.get("AuthorizeToken");
        let AuthorizeToken = localStorage.getItem("AuthorizeToken");

        let params = {
          AgentCode: val,
          SUBJOB: this.$store.state.POL_TRAN.SUBJOB
        }; 

        http.get("AgencyERequest/GetDataAgentCenter?", { headers: { Authorization: `Bearer ${AuthorizeToken}` }, params }).then((res) => { 
          if(res.status == 200) {
            this.Loading = false;

            if(res.data.AGENTCODE == null) { 
              Swal.fire({
              icon: 'error',
                html: '<label class="fs-4 fw-normal font-family">ไม่พบข้อมูลตัวแทน</label>',
              });

              this.disabled = true;
            }
            else {
              this.POL_CODE = res.data.AGENTCODE;
              this.POL_PRENAME = res.data.PRENAME;
              this.POL_NAME = res.data.NAME;
              this.POL_SURNAME = res.data.SURNAME;
              this.CheckSearch = true;
              this.disabled = false;
            }
          }
          else {

          }
        }).catch((error) => {
          this.Loading = false;
          Swal.fire({
            icon: 'error',
            html: '<label class="fs-4 fw-normal font-family">ไม่สามารถค้นหาข้อมูลตัวแทนได้</label>',
          });
        });
      }
    },
    EnterNext() {
      if (this.AgentCode === '' || this.CheckSearch == false) { 
        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">กรุณาระบุตัวแทนที่ต้องการโอนผลงานให้ หรือตรวจสอบความถูกต้องโดยกดแว่นขยาย</label>',
        });
      }
      else {
        this.$store.state.PassTranfer = this.POL_CODE + " " + this.POL_PRENAME + " " + this.POL_NAME + " " + this.POL_SURNAME;
        
        //SET INSERT DATABASE
        this.$store.state.POL_TRAN.AGENTCODE = this.$store.state.AgentCode;
        this.$store.state.POL_TRAN.AGENTCODE_POL_TRAN = this.AgentCode;

        this.$router.push('/FinishTranferWork');
      }
    },
    format(val) { 
      this.AgentCode = String(val).padStart(8, '0');
      return this.AgentCode;
    },
  },
};
</script>

<style scoped>
.btn-CB {
  min-height: 50px;
  font-size: 26px;
  font-size: 1.625rem;
  background-color: #0057a8;
}

/* .footer {
    position: absolute;
    width: 97%;
    margin: 0 auto;
    bottom: 1%;
} */
/* @media screen and (min-width: 375px) and (max-width: 450px) {
  .bg-color {
    background-color: rgb(242, 3, 35);
  }
} */
/* 
@media screen and (max-width: 799px) {
  .bg-color {
    background-color: blue;
  }
} */
</style>